import { render, staticRenderFns } from "./PaymentDescription.vue?vue&type=template&id=a4a3bda6&scoped=true&"
import script from "./PaymentDescription.vue?vue&type=script&lang=ts&"
export * from "./PaymentDescription.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a3bda6",
  null
  
)

export default component.exports